import * as React from 'react';
import { ISegmentFilter } from 'sections/offsite-campaigns/entities/offsiteCampaign';
import { State as CampaignState } from 'entities/lifecycle/lifeCycle';
import { AllFilter } from './AllFilter';
import { Filter } from './Filter';
interface OwnProps {
  segmentId: string;
  segmentFilter: ISegmentFilter;
  campaignState: CampaignState;
  index: number;
  onCustomFilterClick?: () => void;
}

export type Props = OwnProps;

export const SegmentFilterListItem: React.FC<Props> = ({
  segmentId,
  segmentFilter,
  campaignState,
  index,
  onCustomFilterClick,
}) => {
  switch (segmentFilter.type) {
    case 'all':
      return (
        <AllFilter index={index} segmentFilter={segmentFilter} segmentId={segmentId} campaignState={campaignState} />
      );
    case 'custom':
      return (
        <Filter
          index={index}
          segmentFilter={segmentFilter}
          segmentId={segmentId}
          campaignState={campaignState}
          onFilterClick={onCustomFilterClick}
        />
      );
  }
};
